import React from 'react';
import { FormControl, FormHelperText, Stack } from '@mui/material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/en';
import 'dayjs/locale/de';

import advancedFormat from 'dayjs/plugin/advancedFormat';

import { FormFieldProps } from './index';

import { useTranslation } from '../../../contexts/TranslationContext';
import { useFormErrors } from '../../../contexts/FormContext';

dayjs.extend(advancedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);


export default function DateTimeFormField({
    type,
    name,
    label,
    value,
    onChange,
    onKeyUp,
}: FormFieldProps) {
    const { i18n, translate } = useTranslation();
    const { error } = useFormErrors(name);

    let dateVal = null;
    try {
        if (value && dayjs.utc(value).isValid()) {
            dateVal = dayjs.utc(value);
        } else {
            /*if (name.includes('start')) {
        dateVal = dayjs().set('hour', 0).set('minute', 0).set('second', 0);
      }
      if (name.includes('end')) {
        dateVal = dayjs().set('hour', 23).set('minute', 59).set('second', 59);
      }*/
        }
    } catch (e) {}

    return (
        <FormControl
            fullWidth
            error={Boolean(error)}
            sx={{
                borderColor: theme =>
                    error ? theme.palette.error.main : theme.palette.divider,
            }}>
            <Stack spacing={0.5}>
                <LocalizationProvider adapterLocale={i18n} dateLibInstance={AdapterDayjs}>
                    <DateTimePicker
                        label={translate(label)}
                        value={dateVal}
                        timezone="system"
                        onChange={value => onChange(value?.toISOString() ?? '')}
                        displayWeekNumber
                        slotProps={{
                            textField: {
                                InputLabelProps: {
                                    sx: { lineHeight: 1, color: 'text.secondary' },
                                },
                            },
                        }}
                        timeSteps={{
                            hours: 1,
                            minutes: 1,
                            seconds: 15,
                        }}
                    />
                </LocalizationProvider>
                {Boolean(error) && (
                    <FormHelperText error={Boolean(error)} id={name + '-error'}>
                        {translate(error ?? 'error')}
                    </FormHelperText>
                )}
            </Stack>
        </FormControl>
    );
}
